import { render, staticRenderFns } from "./ldmb.vue?vue&type=template&id=4ce97ff5&scoped=true&"
import script from "./ldmb.vue?vue&type=script&lang=js&"
export * from "./ldmb.vue?vue&type=script&lang=js&"
import style0 from "./ldmb.vue?vue&type=style&index=0&id=4ce97ff5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce97ff5",
  null
  
)

export default component.exports